import { ELEM_TYPES } from './constants/ElementTypes'
import _ from 'lodash'
import { List, Map } from 'immutable'
import { detectIsTargetKeyInRepeatEl } from './StateUtils'
import { getElementDataRoot } from '../constants/getElementDataRoot'
import { normalizeKeyPath } from './PathUtils'
import { getMappingCount } from '../constants/getMappingCount'

// === Handler functions ===

const handleFileUpload = ({ sourceElementPath, fromUID, index, portalState }) => {
  let path = String(normalizeKeyPath(sourceElementPath)).replace(/:/g, '.').split('.')
  path[path.length - 1] = fromUID
  path.push('ft_fileupload')
  if (!_.isNil(index)) {
    path.push(index)
  }
  return _.get(portalState, path, '')
}

const handleFtStripRow = ({ index }) => (typeof index === 'number' ? index + 1 : index)

const handleTotalRows = ({ sourceElementPath, fromUID, repeatRoot, retState }) => {
  const stripPageUID = sourceElementPath.split(':')[0]
  const stripState = retState.getIn(['state', stripPageUID, fromUID], Map())
  return getMappingCount(stripState.toJS())
}

const handlePageParam = ({ sourceElementPath, portalState }) => {
  const path = sourceElementPath.replace(/:/g, '.')
  return _.get(portalState, path, '')
}

const handleParam = ({ sourceElementPath, params }) => {
  const path = sourceElementPath.replace(/:/g, '.')
  return _.get(params, path, '')
}

const handlePowerTableWidget = ({ sourceElementPath, index, portalState, setIsTableMode }) => {
  setIsTableMode(true)
  const path = sourceElementPath.split(':')
  let val = _.get(portalState, path, '')
  return _.isArray(val) ? val[index] : val
}

const handleTableWidget = ({ sourceElementPath, index, portalState, setIsTableMode }) => {
  setIsTableMode(true)
  let path = sourceElementPath.split(':')
  path = [..._.initial(path), index, _.last(path)]
  return _.get(portalState, path, '')
}

const handleDefault = ({ sourceElementPath, index, retState, portalState }) => {
  let path = String(normalizeKeyPath(sourceElementPath)).replace(/:/g, '.').split('.')
  const isPossibleRepeat = detectIsTargetKeyInRepeatEl(path, retState)
  const isRepeatContainer = !_.isNil(index) && isPossibleRepeat

  if (isRepeatContainer) {
    const elem = retState.getIn(
      [
        ...getElementDataRoot(['Header', 'Footer'].includes(path[0]) ? 'project' : retState.get('page')),
        'elements',
        path[2],
      ],
      Map()
    )
    const controlType = elem.getIn(['props', 'control'])
    if (
      elem.get('type') === ELEM_TYPES.FORM_FIELD &&
      [ELEM_TYPES.DATE_RANGE, ELEM_TYPES.RADIO, ELEM_TYPES.LOOKUP].includes(controlType)
    ) {
      path?.splice(path.length - 1, 0, index)
    } else {
      path?.push(index)
    }
  }

  return _.get(portalState, path, '')
}

// === Handler dispatch map ===

const getHandler = ({ fromSubType, sourceElementPath, fromGroup, fromUID, repeatRoot }) => {
  const rules = [
    { check: () => fromSubType === ELEM_TYPES.FILE_UPLOAD, result: 'fileUpload' },
    { check: () => _.endsWith(sourceElementPath, ':ftStripRow'), result: 'ftStripRow' },
    { check: () => _.endsWith(sourceElementPath, '-totalRows') && repeatRoot.includes(fromUID), result: 'totalRows' },
    { check: () => fromGroup === ELEM_TYPES.PAGE_PARAM, result: 'pageParam' },
    { check: () => fromGroup === ELEM_TYPES.PARAM, result: 'param' },
    { check: () => _.startsWith(fromGroup, ELEM_TYPES.POWER_TABLE_WIDGET), result: 'powerTableWidget' },
    { check: () => _.startsWith(fromGroup, ELEM_TYPES.TABLE_WIDGET), result: 'tableWidget' },
  ]

  const matched = rules.find((rule) => rule.check())
  return matched ? matched.result : 'defaultHandler'
}

const handlerMap = {
  fileUpload: handleFileUpload,
  ftStripRow: handleFtStripRow,
  totalRows: handleTotalRows,
  pageParam: handlePageParam,
  param: handleParam,
  powerTableWidget: handlePowerTableWidget,
  tableWidget: handleTableWidget,
  defaultHandler: handleDefault,
}

export const extractSourceValue = (action, index, portalState, retState, params, keyPath, isList) => {
  let value = ''
  let isTableMode = false

  const repeatRoot = retState.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
  const sourceElementPath = String(action.getIn(['from', 'value'], ''))
  const fromUID = action.getIn(['from', 'uid'], '')
  const fromGroup = action.getIn(['from', 'group'])
  const fromSubType = action.getIn(['from', 'subType'])

  const setIsTableMode = (v) => {
    isTableMode = v
  }

  try {
    const handlerKey = getHandler({ fromSubType, sourceElementPath, fromGroup, fromUID, repeatRoot })
    const handler = handlerMap[handlerKey]

    value = handler({
      sourceElementPath,
      fromUID,
      fromGroup,
      fromSubType,
      index,
      portalState,
      retState,
      params,
      repeatRoot,
      setIsTableMode,
    })
  } catch (err) {
    // optional: log error
  }

  if (isList && !keyPath.includes('ftListValue') && !keyPath.includes('ftListLabel')) {
    value = { ftListValue: value }
  }

  return { value, isTableMode }
}
